export const rowTablePipe = (data) => {
  const rowData = data.map((item) => {
    return Object.keys(item).reduce(
      (acc, key) => {
        acc[key] = { default: item[key] };
        return acc;
      },
      { defaultValue: "- - - - - - - - - - - - - -" }
    );
  });
  return rowData;
};
